module.exports = __webpack_public_path__ + "img/y- (20).e2c74015.jpg";